import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import AddMappingButton from './AddMappingButton';
import DeleteMappingButton from './DeleteMappingButton';
import EditMappingButton from './EditMappingButton';
import DisableMappingButton from './DisableMappingButton';
import MarkCodeComplete from './MarkCodeComplete';
import ReviewConfirmMapping from './ReviewConfirmMapping';
import MappingCommentsIcon from './MappingCommentsIcon';
import hasPermission from '../../../../../../../../Shared/hasPermission';

const RowActionsField = ({
    isBorderTop = false,
    canFlagForReview,
    code,
    mapping,
    canDelete,
}) => {
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canReadComments = hasPermission('CodeMapsCommentsRead', permissions);

    let classes = 'col-actions py-3 border-dark text-nowrap';
    if (isBorderTop) classes += ' border-top';
    const practiceIsFinalized = useSelector(
        (state) => state.daylight.practiceIsFinalized
    );
    const isHidden = practiceIsFinalized || !canFlagForReview;
    const updatingCodeId = useSelector(
        (state) => state.daylight.updatingCodeId
    );
    const updatingMappingId = useSelector(
        (state) => state.daylight.updatingMappingId
    );

    const isCodeUpdating = code.id === updatingCodeId;
    const isMappingUpdating =
        mapping.id === updatingMappingId || mapping.id === undefined; //if mapping.id is undefined, it means it is a new mapping
    return (
        <td className={classes}>
            {!isHidden && (
                <span className="d-flex justify-content-end align-items-center">
                    {/* is this row the first row */}
                    {isBorderTop && (
                        <div className='record-actions mr-2 border-right'>
                            <ReviewConfirmMapping
                                code={code}
                                isUpdating={isCodeUpdating}
                            />
                            <MarkCodeComplete
                                code={code}
                                isUpdating={isCodeUpdating}
                            />
                            {/*don't need to block actions while updating*/}
                            <AddMappingButton code={code} />
                            <DisableMappingButton
                                code={code}
                                mapping={mapping}
                                isUpdating={isMappingUpdating}
                            />
                        </div>
                    )}

                    {canReadComments && (
                        <MappingCommentsIcon
                            code={code}
                            mapping={mapping}
                            isUpdating={isMappingUpdating}
                        />
                    )}

                    <EditMappingButton
                        code={code}
                        mapping={mapping}
                        isUpdating={isMappingUpdating}
                    />

                    {canDelete && (
                        <DeleteMappingButton
                            code={code}
                            mapping={mapping}
                            isUpdating={isMappingUpdating}
                        />
                    )}
                </span>
            )}
        </td>
    );
};

export default RowActionsField;
